/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { typeDiffusionPackSchema } from "./typeDiffusionPackSchema.ts";
import { z } from "zod";

export const produitOrganisationSchema = z.object({
      "id": z.number().int().describe("ID de la ligne produit_organisation").optional(),
  "code": z.string().describe("Code du produit souscrit par l'organisation").optional(),
  "label": z.string().describe("Nom du produit souscrit par l'organisation").optional(),
  "quota": z.number().int().describe("Quota souscrit pour ce produit (absent si illimité)").optional(),
  "typeDiffusion": z.lazy(() => typeDiffusionPackSchema).describe("Type de diffusion du pack souscrit (rabattu depuis le vocabulaire de la base — limite max/min, consommation → LIMITED ; illimite → UNLIMITED)").optional(),
  "diffuseurExterneOrganisationId": z.string().describe("Identifiant de l'organisation chez le diffuseur externe").optional()
      })